export default __webpack_public_path__ + "static/media/Adazeus.e7de2933.png";